import { IBestDataset } from '../../../../types/analytics';

const WRF_PATTERN = /wrf/i;

export function isWrfDatasetName(name: string): boolean {
  return WRF_PATTERN.test(name);
}

export function isSelectableReportDataset(dataset: IBestDataset): boolean {
  return !isWrfDatasetName(dataset.value);
}

export function filterSelectableReportDatasets(
  datasets: IBestDataset[]
): IBestDataset[] {
  return datasets.filter(isSelectableReportDataset);
}

export function filterDefaultReportDatasets(
  defaults: Array<{ key: string; value: string }>,
  selectableDatasets: IBestDataset[]
): Array<{ key: string; value: string }> {
  const allowedDatasetIds = new Set(selectableDatasets.map((d) => d.id));
  return defaults.filter((d) => allowedDatasetIds.has(d.value));
}
